import { gate } from 'hub-http/gates';
export const GATES = {
  DPR_V2: gate('PrivacyCenter:DataPrivacyRequest'),
  GLOBAL_SEARCH: gate('settings-nav:new-global-search-icon'),
  PARTNER_SETTINGS: gate('PartnerServices:PartnerDataSharingSettings')
};